import delParam from './delParam'
import serializeParam from './serializeParam'
import forEach from 'lodash.foreach'

export default function (arr, url) {
  var names = [];
  forEach(arr, function (v, k) {
    names.push(k);
  });
  url = delParam(names, url);
  var postfix = serializeParam(arr);
  url += /(\?|&)$/.test(url) ? '' + postfix : /\?/.test(url) ? '&' + postfix : '?' + postfix;
  return url;
}